import React, { useEffect, useMemo, useState } from 'react';
import {
  Table,
  Button,
  Select,
  Input,
  Card,
  Row,
  Col,
  Modal,
  message,
  Space,
  DatePicker,
  Typography,
  Progress,
  Tooltip
} from 'antd';
import { DownloadOutlined, FilterOutlined, SearchOutlined, SyncOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import { URL_API } from '@configs/';
import './style.css';
import { showError } from '@components/notification';
import { communityList, convertLocaltimeToUTC, formatCurrency } from '@utils/utils';
import {
  apiGetOriginalData,
  apiSyncData,
  apiSyncTimeData
} from '@services/ManageDevices/DeviceServices';
import { loadFromLocalStorageObjectFromBase64, saveToLocalStorage } from '@databases/localStorage';
import { contantAuthentication } from '@contants/';
import { get, isEmpty, isNumber } from 'lodash';
import { SelectCommunity } from '@page/Common/SelectCommunity';
import CustomerSelect from '@components/Select/SelectCustomer';
import {
  apiGetStatisticsCustomerByDay,
  apiGetStatisticsCustomerByDayV2,
  apiGetStatisticsData
} from '@services/ManageCustomers/CustomerServices';
import { ADMIN_ROLE } from '@utils/constant';
import Chart from '@components/charts/Chart';
import { COLORS } from '@components/charts/chart.constant';
import dayjs from 'dayjs';
import { usePermission } from '@contexts/Auth/UsePermission';
import { Link } from 'react-router-dom';
import FilterAdvanceDrawer from '@components/FilterAdvance';
import ConsumptionCard from './ConsumptionCard';

const { Option } = Select;

const { RangePicker } = DatePicker;

export default function List() {
  const [data, setData] = useState([]);
  const [flagSearch, setFlagSearch] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState('HP');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [rangeDateString, setRangeDateString] = useState([
    moment().subtract(1, 'day').format('YYYY-MM-DD'),
    moment().subtract(1, 'day').format('YYYY-MM-DD')
  ]);
  const [serialNo, setSerialNo] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const user = JSON.parse(loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH));
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, 'day'), // Start date: 1 day ago
    dayjs().subtract(1, 'day') // End date: today
  ]);
  const { dailyConsumption } = usePermission();
  const [isOpen, setIsOpen] = useState(false);
  const [dataFilterAdvance, setDataFilterAdvance] = useState({});
  const [sumConsumption, setSumConsumption] = useState(0);
  const openDrawer = () => {
    setIsOpen(true);
  };

  const onDrawerClose = () => {
    setIsOpen(false);
  };
  const fetchData = async () => {
    try {
      setSelectedRowKey(null);
      setSelectedRow(null);
      setLoadingFetch(true);
      const res = await apiGetStatisticsCustomerByDayV2({
        page: currentPage,
        size: pageSize,
        keyWord: search ?? undefined,
        serialNo: serialNo,
        customerId: customerId ?? undefined,
        community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
        fromDate: rangeDateString?.length ? rangeDateString[0] : undefined,
        toDate: rangeDateString?.length ? rangeDateString[1] : undefined,
        ...dataFilterAdvance
      });
      setData(
        res.data?.data?.map((item, index) => ({
          ...item,
          stt: (currentPage - 1) * pageSize + 1 + index
        }))
      );
      setTotalItems(res.data?.meta?.total);
      setSumConsumption(res.data?.meta?.sum_consumption || 0);
    } catch (err) {
      showError({ message: 'Something went wrong!' });
      console.log(err);
    } finally {
      setLoadingFetch(false);
    }
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const onChangeDateRange = (dates, dateStrings) => {
    setRangeDateString(dateStrings);
    setDateRange(dates);
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (!search && !dateRange?.length && currentPage === 1) {
  //       setCurrentPage(1);
  //       fetchData();
  //     }
  //   }, 50000);

  //   return () => clearInterval(interval);
  // }, [search, selectedCommunity, dateRange?.length, currentPage, custId]);

  useEffect(() => {
    if (customerId) {
      fetchData();
    }
  }, [currentPage, pageSize, flagSearch]);

  const columns = [
    {
      title: 'DBĐD',
      dataIndex: 'code',
      fixed: 'left',
      width: 80,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>
          {`${record?.code}
          `}
        </p>
      )
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'name',
      fixed: 'left',
      width: 200,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>
          {`${record?.name}
          `}
        </p>
      )
    },
    {
      title: 'Khu vực',
      dataIndex: 'zone',
      width: 70
    },
    {
      title: 'DHK',
      dataIndex: 'parent_device',
      width: 70
    },
    {
      title: 'Tuyến',
      dataIndex: 'route',
      width: 80
    },
    {
      title: 'Cỡ ĐH',
      dataIndex: 'size',
      width: 90
    },
    {
      title: 'Thiết bị',
      dataIndex: 'serial_no',
      width: 100,
      render: (text, record) => (
        <p style={{ color: 'blue', margin: 0 }}>{`SN:${record.serial_no}/ IMEI:${record.imei}`}</p>
      )
    },
    {
      title: 'Ngày thống kê',
      dataIndex: 'denseData_startCollectionTime',
      key: 'denseData_startCollectionTime',
      render: (_, record) => (
        <>
          {record?.denseData_startCollectionTime
            ? record?.denseData_startCollectionTime
            : 'Chưa có dữ liệu'}
        </>
      ),
      width: 150
    },
    {
      title: 'Chỉ số tại thời điểm 00:00 (lít)',
      dataIndex: 'start_meter_reading_at_day',
      key: 'start_meter_reading_at_day',
      render: (_, record) => (
        <>
          {isNumber(record?.start_meter_reading_at_day)
            ? formatCurrency(record?.start_meter_reading_at_day)
            : '-'}
        </>
      ),
      width: 150
    },
    {
      title: 'Tiêu thụ trong ngày (lít)',
      dataIndex: 'water_consumption_of_the_day',
      key: 'water_consumption_of_the_day',
      render: (_, record) => (
        <>
          {isNumber(record?.water_consumption_of_the_day)
            ? formatCurrency(record?.water_consumption_of_the_day)
            : '-'}
        </>
      ),
      width: 120
    },
    {
      title: 'Lượng nước tiêu thụ qua các giờ (lít)',
      children: [
        ...Array.from({ length: 24 }, (_, index) => ({
          title: `${index}:00`,
          dataIndex: `hour${index}`,
          key: `hour${index}`,
          width: 80,
          render: (_, record) => (
            <>
              {isNumber(record?.diffirenceOfTheFlowWaterMeter?.[index])
                ? formatCurrency(record?.diffirenceOfTheFlowWaterMeter?.[index])
                : '-'}
            </>
          )
        }))
      ]
    }
  ];

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSerialNoChange = (e) => {
    setSerialNo(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const handleExportExcelButtonClick = async () => {
    let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
    if (!isEmpty(user)) {
      user = JSON.parse(user);
    }
    setLoading(true);
    const response = await axios.get(
      `${URL_API}/api/customer/v2/statistics-customer-by-day/export`,
      {
        params: {
          keyWord: search ?? undefined,
          serialNo: serialNo,
          customerId: customerId ?? undefined,
          community: selectedCommunity === 'ALL' ? undefined : selectedCommunity,
          fromDate: rangeDateString?.length ? rangeDateString[0] : undefined,
          toDate: rangeDateString?.length ? rangeDateString[1] : undefined,
          ...dataFilterAdvance
        },
        headers: {
          Authorization: `Bearer ${user?.accessToken}`
        },
        responseType: 'blob'
      }
    );
    const dateKey = moment().format('YYYYMMDD.HHmmss');
    const type = response.headers['content-type'];
    const blob = new Blob([response.data], { type: type });
    const link1 = document.createElement('a');
    link1.href = window.URL.createObjectURL(blob);
    link1.setAttribute('download', `Thong_ke_tieu_thu_theo ngày_${dateKey}.xlsx`);
    document.body.appendChild(link1);
    link1.click();
    setLoading(false);
  };
  const [loadingSync, setLoadingSync] = useState(false);
  const handleSyncButtonClick = async () => {
    try {
      setLoadingSync(true);
      const res = await apiSyncTimeData();
      // message.success('Cập nhật thành công !');
      if (customerId) {
        fetchData();
      }
    } catch (e) {
      console.log(e);
      message.error('Có lỗi xảy ra !');
    } finally {
      setLoadingSync(false);
    }
  };

  const handleRowClick = async (row) => {
    if (!row?.diffirenceOfTheFlowWaterMeter?.length) {
      showError('Khách hàng không có dữ liệu ngày hôm nay!');
      return;
    }
    setSelectedRowKey(row?.stt);
    setSelectedRow(row);
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };

  const dataCharts = [
    {
      name: 'Tiêu thụ giờ',
      data: selectedRow
        ? selectedRow?.diffirenceOfTheFlowWaterMeter?.map((value) => (isNumber(value) ? value : 0))
        : [],
      type: 'bar'
    }
  ];

  // Data for daily consumption chart
  const dailyConsumptionChartData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return [
      {
        name: 'Tiêu thụ theo ngày',
        data: data.map((item) => item.water_consumption_of_the_day || 0),
        type: 'bar'
      }
    ];
  }, [data]);

  const dailyConsumptionLabels = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map((item) => item.denseData_startCollectionTime || '');
  }, [data]);

  useEffect(() => {
    handleSyncButtonClick();
  }, []);

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>
          <Typography.Title level={4} style={{ color: '#0051A9' }}>
            Thống kê tiêu thụ theo ngày từng khách hàng
          </Typography.Title>
        </Col>
        {dailyConsumption.export && (
          <Col>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportExcelButtonClick}
              loading={loading}
              style={{
                backgroundColor: '#EAF5EF',
                borderColor: '#EAF5EF',
                color: '#0051A9',
                height: '36px',
                fontWeight: '500'
              }}>
              Xuất báo cáo
            </Button>
          </Col>
        )}
      </Row>
      <Card>
        <Row gutter={[8, 8]} style={{ marginBottom: '16px' }}>
          {/* <Col md={4} xs={6}>
            <Input
              value={serialNo}
              onChange={handleSerialNoChange}
              placeholder="Tìm kiếm số serial..."
              style={{ width: '100%', marginBottom: '16px', height: '36px' }}
            />
          </Col> */}
          {/* <Col md={1} xs={1}>
            <Button
              icon={<FilterOutlined />}
              onClick={openDrawer}
              style={{
                backgroundColor: '#F4F5F7',
                color: '#626D7C',
                border: 'none',
                width: '100%'
              }}
            />
          </Col> */}
          <Col md={8} xs={6}>
            <CustomerSelect
              onDefaultSet={(code) => {
                setCustomerId(code);
                // Trigger search with default customer
                setFlagSearch((prev) => !prev);
              }}
              onChange={(value, option) => {
                setCustomerId(option?.code || null);
              }}
            />
          </Col>
          {/* <Col md={4} xs={6}>
            <Input
              style={{ height: '36px', width: '100%', fontSize: '18px' }}
              size="small"
              placeholder="Tìm kiếm theo mã tên KH..."
              value={search}
              onChange={handleSearchChange}
              onPressEnter={() => {
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
            />
          </Col> */}
          <Col md={8} xs={8}>
            <RangePicker
              value={dateRange}
              onChange={onChangeDateRange}
              style={{ width: '100%', height: '36px', fontSize: '18px' }}
              format="YYYY-MM-DD"
              placeholder={['Từ ngày', 'Đến ngày']}
              defaultPickerValue={[dayjs().subtract(1, 'month'), dayjs()]}
            />
          </Col>
          {/* <Col md={4} xs={6}>
            <SelectCommunity value={selectedCommunity} onChange={setSelectedCommunity} />
          </Col> */}

          <Col md={4} xs={6}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {
                if (!dateRange || !dateRange[0] || !dateRange[1]) {
                  message.error('Vui lòng chọn khoảng thời gian!');
                  return;
                }
                setCurrentPage(1);
                setFlagSearch(!flagSearch);
              }}
              style={{
                height: '36px',
                backgroundColor: '#0051A9',
                borderColor: '#0051A9',
                fontSize: '18px'
              }}>
              Tìm kiếm
            </Button>
          </Col>
          <ConsumptionCard loadingFetch={loadingFetch} sumConsumption={sumConsumption} />
        </Row>

        <Table
          bordered
          // size="middle"
          loading={loadingFetch}
          dataSource={data || []}
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalItems,
            showSizeChanger: true,
            onChange: handleChangePage,
            onShowSizeChange: handleChangePageSize,
            showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          onRow={(record) => ({
            onClick: () => handleRowClick(record), // Click handler for rows
            style: {
              cursor: 'pointer',
              backgroundColor: selectedRowKey === record.stt ? '#e6f7ff' : undefined
            }
          })}
          style={{
            borderRadius: '4px',
            thead: { backgroundColor: '#DBDFE5', color: '#626D7C' },
            fontSize: '30px'
          }}
          scroll={{ x: 'max-content', y: 400 }}
        />
      </Card>
      {(selectedRowKey || (data && data.length > 0)) && (
        <Row gutter={16} style={{ marginTop: '16px' }}>
          {/* Daily Consumption Chart - Left */}
          {data && data.length > 0 && (
            <Col xs={24} md={12}>
              <Card>
                <Typography.Title level={5} style={{ marginBottom: '16px' }}>
                  Biểu đồ tiêu thụ theo các ngày
                </Typography.Title>
                <Chart
                  options={{
                    colors: COLORS,
                    chart: {
                      zoom: {
                        enabled: false
                      },
                      toolbar: {
                        show: true
                      },
                      events: {
                        dataPointSelection: (event, chartContext, config) => {
                          const dataIndex = config.dataPointIndex;
                          if (data && data[dataIndex]) {
                            handleRowClick(data[dataIndex]);
                          }
                        }
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        columnWidth: '18px',
                        borderRadius: 4
                      }
                    },
                    fill: {
                      opacity: 1
                    },
                    dataLabels: {
                      enabled: false
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      colors: ['transparent']
                    },
                    xaxis: {
                      categories: dailyConsumptionLabels
                    },
                    yaxis: {
                      show: true,
                      title: {
                        text: 'Lượng nước (lít)'
                      }
                    },
                    grid: {
                      show: true
                    },
                    tooltip: {
                      y: {
                        formatter: (val) => `${formatCurrency(val)} lít`
                      }
                    },
                    legend: {
                      horizontalAlign: 'left'
                    }
                  }}
                  type="bar"
                  series={dailyConsumptionChartData}
                  height={400}
                />
              </Card>
            </Col>
          )}

          {/* Hourly Consumption Chart - Right */}
          {selectedRowKey && (
            <Col xs={24} md={12}>
              <Card>
                <Typography.Title level={5} style={{ marginBottom: '8px' }}>
                  Biểu đồ thống kê tiêu thụ các giờ trong ngày
                </Typography.Title>
                <Typography.Text style={{ fontSize: '14px', color: '#666' }}>
                  {`${selectedRow?.code} - ${selectedRow?.name}`}{' '}
                  {`(${selectedRow?.denseData_startCollectionTime})`}
                </Typography.Text>
                <Chart
                  options={{
                    colors: COLORS,
                    chart: {
                      zoom: {
                        enabled: false
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        columnWidth: '18px',
                        borderRadius: 4
                      }
                    },
                    fill: {
                      opacity: 1
                    },
                    dataLabels: {
                      enabled: false
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      colors: ['transparent']
                    },
                    labels: [
                      '00',
                      '01',
                      '02',
                      '03',
                      '04',
                      '05',
                      '06',
                      '07',
                      '08',
                      '09',
                      '10',
                      '11',
                      '12',
                      '13',
                      '14',
                      '15',
                      '16',
                      '17',
                      '18',
                      '19',
                      '20',
                      '21',
                      '22',
                      '23'
                    ],
                    yaxis: {
                      show: true,
                      title: {
                        text: 'Lượng nước (lít)'
                      }
                    },
                    grid: {
                      show: true
                    },
                    tooltip: {
                      y: {
                        formatter: (val) => `${formatCurrency(val)} lít`
                      }
                    },
                    legend: {
                      horizontalAlign: 'left'
                    }
                  }}
                  type="bar"
                  series={dataCharts}
                  height={400}
                />
              </Card>
            </Col>
          )}
        </Row>
      )}
      <FilterAdvanceDrawer
        setCurrentPage={setCurrentPage}
        isOpen={isOpen}
        onDrawerClose={onDrawerClose}
        dataFilterAdvance={dataFilterAdvance}
        setDataFilterAdvance={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
      />
    </div>
  );
}
